<template>
    <v-btn @click="$emit('click')" icon class="rounded mx-1" large color="green darken-4"><v-icon>mdi-microsoft-excel</v-icon></v-btn>
</template>
<script>
export default {
    props:['on', 'value'],
    mounted(){
    }
}
</script>
